import { useQuery } from "@tanstack/react-query";
import { type FC, useState } from "react";
import type { MetaAdsInterestTarget } from "shared";
import { useDebounceValue } from "usehooks-ts";
import { Api } from "../../api.config";
import { useCampaignWizard } from "../CampaignWizardContext";

export const InterestTargetingSection: FC = () => {
	const { draft, updateDraft } = useCampaignWizard();
	const [query, setQuery] = useState("");
	const [debouncedQuery] = useDebounceValue(query, 400);
	const interests = draft.interests ?? [];

	const { data: results = [] } = useQuery({
		queryKey: ["META_ADS_INTEREST_SEARCH", debouncedQuery],
		queryFn: () =>
			Api.SearchMetaAdsInterests(debouncedQuery).then((r) => r.data),
		enabled: debouncedQuery.length >= 2,
	});

	const addInterest = (interest: MetaAdsInterestTarget) => {
		if (interests.some((item) => item.id === interest.id)) return;
		updateDraft({ interests: [...interests, interest] });
		setQuery("");
	};

	const removeInterest = (id: string) => {
		updateDraft({
			interests: interests.filter((item) => item.id !== id),
		});
	};

	return (
		<div>
			<h6>Interest Targeting</h6>
			<input
				type="text"
				className="form-control form-control-sm"
				placeholder="Search interests..."
				value={query}
				onChange={(e) => setQuery(e.target.value)}
			/>
			{debouncedQuery.length >= 2 && results.length > 0 && (
				<div
					style={{
						border: "1px solid #dee2e6",
						borderRadius: 8,
						marginTop: 8,
						maxHeight: 160,
						overflowY: "auto",
					}}
				>
					{results.map((interest) => (
						<button
							key={interest.id}
							type="button"
							className="btn btn-sm btn-link w-100 text-start"
							onClick={() => addInterest(interest)}
						>
							{interest.name}
						</button>
					))}
				</div>
			)}
			{interests.length > 0 && (
				<div
					style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 8 }}
				>
					{interests.map((interest) => (
						<span key={interest.id} className="badge bg-primary">
							{interest.name}
							<button
								type="button"
								className="btn-close btn-close-white ms-2"
								style={{ fontSize: 10 }}
								aria-label={`Remove ${interest.name}`}
								onClick={() => removeInterest(interest.id)}
							/>
						</span>
					))}
				</div>
			)}
		</div>
	);
};
